// Libellés FR des statuts et des codes de raison rendus par
// `/news-radar-source-requests` (cf. report-api
// `app/services/news_radar/source_request.py`). Un code inconnu est affiché
// tel quel plutôt que masqué : mieux vaut un code brut qu'une cellule vide.

export const MEDIA_TYPE_LABELS = {
  written: "Écrit",
  video: "Vidéo",
};

export const REQUEST_STATUS = {
  pending: { label: "En attente", variant: "pending" },
  processing: { label: "En cours", variant: "running" },
  done: { label: "Terminée", variant: "completed" },
  failed: { label: "Échouée", variant: "failed" },
};

export const ITEM_STATUS = {
  pending: { label: "À vérifier", variant: "pending" },
  accepted: { label: "Acceptée", variant: "success" },
  rejected: { label: "Refusée", variant: "warning" },
  error: { label: "Erreur", variant: "error" },
};

export const REASON_LABELS = {
  created: "Source créée",
  reactivated: "Source réactivée (elle existait, inactive)",
  invalid_url: "URL invalide",
  duplicate_in_batch: "Doublon dans la demande",
  already_configured: "Déjà suivie par ce site",
  already_covered_other_source:
    "Déjà couverte par une autre source du site (même domaine)",
  covered_by_existing_feed:
    "Couverte par un flux déjà suivi (≥ 80 % d'articles communs)",
  feed_unreadable: "Flux illisible",
  page_unreachable: "Page injoignable",
  page_blocked: "Le site bloque les robots, et aucun flux RSS n'a été trouvé",
  rss_app_restricted: "Création d'un flux RssApp réservée aux superadmins",
  unsupported_url: "URL non prise en charge",
  error: "Erreur technique",
};

export const OPEN_REQUEST_STATUSES = ["pending", "processing"];

export const isRequestOpen = (status) => OPEN_REQUEST_STATUSES.includes(status);

export const requestStatus = (status) =>
  REQUEST_STATUS[status] || { label: status || "?", variant: "neutral" };

export const itemStatus = (status) =>
  ITEM_STATUS[status] || { label: status || "?", variant: "neutral" };

export const reasonLabel = (code) => (code ? REASON_LABELS[code] || code : "");

export const mediaTypeLabel = (mediaType) =>
  MEDIA_TYPE_LABELS[mediaType] || mediaType || "";
